import { DepartureScheduleQueryParams } from "@interfaces/departure-schedule";

export const departureScheduleQueryKeys = {
  allDepartureSchedule: (params?: DepartureScheduleQueryParams) => [ params],
};
